import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import withWidth from 'material-ui/utils/withWidth'
import {withStyles} from 'material-ui/styles/index'
import Container from '../../../common/components/Container'
import ErrorMessage from '../../../common/components/ErrorMessage'
import HeaderProgress from '../../../common/components/HeaderProgress'
import Typography from 'material-ui/Typography'
import {Button, Panel, PanelItem} from '../../../components'
import moment from '../../../common/moment'
import Table, {TablePagination, TableFooter, TableRow} from 'material-ui/Table'

const styles = theme => ({
  topBanner: {
    marginTop: 0,
    background: `linear-gradient(135deg, ${theme.palette.gradient.start} 0%, ${theme.palette.gradient.end} 100%)`,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: -47,
    },
  },
  title: {
    color: '#FFF',
    paddingTop: 30,
  },
  total: {
    color: '#FFF',
  },
  listTitle: {
    fontSize: '1.25rem',
    paddingTop: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 4,
    paddingLeft: 0,
  },
})

class Balance extends React.Component {

  state = {
    page: 0,
    rowsPerPage: 10,
  }

  handleChangePage = (event, page) => {
    this.setState({page})
  }

  handleChangeRowsPerPage = event => {
    this.setState({rowsPerPage: event.target.value})
  }

  render() {
    const {classes, error, isFetching, balance, activity} = this.props
    const {rowsPerPage, page} = this.state

    if (error !== '' && error !== undefined) {
      return <ErrorMessage error={error}/>
    }

    return (
      <div style={{minHeight: 520}}>
        <HeaderProgress show={isFetching}/>
        <div className={classes.topBanner}>
          <Typography variant={'subheading'} className={classes.title} gutterBottom={true}>Balance Actual</Typography>
          <Typography variant={'display2'} className={classes.total} gutterBottom={true}>
            ${balance.toFixed(2)}
          </Typography>
          <Button style={{opacity: 0}}>Retirar fondos</Button>
        </div>
        <Container>
          <Typography variant="title" className={classes.listTitle}>Actividad</Typography>
          <div>
            {activity.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(a => (
              <Panel key={a.get('ID')} style={{marginBottom: 10}}>
                <PanelItem button={false}>
                  <div style={{display: 'flex', flex: 1, paddingLeft: 16}}>
                    <div style={{flex: 1}}>
                      <Typography variant={'body2'} color={'textSecondary'}>
                        {a.getIn(['BalanceDetailType', 'Type'])} {a.getIn(['RentData', 'Object'])}
                      </Typography>
                      <Typography variant={'body1'} color={'textSecondary'}>
                        {moment(a.get('Date')).format('LLL')}
                      </Typography>
                    </div>
                    <div>
                      <Typography variant={'body2'} color={'primary'} style={{marginTop: 20}}>
                        ${a.get('Amount')}
                      </Typography>
                    </div>
                  </div>
                </PanelItem>
              </Panel>
            ))}
          </div>
          <Table>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={activity.length}
                  onChangePage={this.handleChangePage}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Container>
      </div>
    )
  }

  static propTypes = {
    isFetching: PropTypes.bool,
    error: PropTypes.string,
    balance: PropTypes.number.isRequired,
    activity: PropTypes.array.isRequired,
  }
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(Balance)



// WEBPACK FOOTER //
// ./src/sections/balance/components/balance.js